<svg class="polyline-wrapper" [attr.viewBox]="viewBox" preserveAspectRatio="none">
    <polyline [attr.stroke]="activePolyline.color"
        [attr.stroke-width]="activePolyline.width"
        [attr.points]="activePolyline.points"
        fill="none">
    </polyline>
</svg>
